<template>
  <div id="welcome-module">
    <div class="bg-brand text-white p-8 shadow-lg pointer-events-auto md:rounded">
      <!-- Title -->
      <div class="w-full mb-8">
        <img class="block mb-8" :src="require('../assets/img/lcf_csf_lockup.png')" />
        <div class="text-2xl font-bold mb-4 pt-8 border-t">Fashion &amp; Sustainability</div>
        <div class="text-2xl">Understanding Luxury Fashion in&nbsp;a Changing&nbsp;World</div>
      </div>
      <!-- Buttons -->
      <div v-if="addYourselfVisible">
        <div><csf-button type="primary" class="mb-4" @click="$emit('add')">Add yourself</csf-button></div>
        <div><csf-button class="mb-4" @click="showRandom">Show random learner</csf-button></div>
      </div>
      <div v-else>
        <div><csf-button type="primary" class="mb-4" @click="showRandom">Show random learner</csf-button></div>
        <div><csf-button class="mb-4" @click="openFL"><span class="pr-3">&larr;</span>Return to FutureLearn</csf-button></div>
      </div>
      <div>
        <csf-button class="md:hidden" @click="$emit('close')">Browse map</csf-button>
      </div>
    </div>
  </div>
</template>

<script>
import CsfButton from "../components/csf-button.vue";

export default {
  name: "welcome-module",
  components: { CsfButton },
  computed: {
    addYourselfVisible() {
      return !this.$store.getters.currentUserHasSavedEntry;
    }
  },
  methods: {
    showRandom() {
      this.$emit("showRandom");
    },
    openFL() {
      window.location.href =
        "https://www.futurelearn.com/courses/fashion-and-sustainability";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/variables";
</style>



// WEBPACK FOOTER //
// WelcomeModule.vue?b64a88ee